import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BsPlus } from "react-icons/bs";
import List from "./List";
import { MovieT } from "../type";

// Columns
const columns = [
    { key: "title", label: "Title" },
    { key: "fileSize", label: "File size" },
    { key: "duration", label: "Duration" },
];


export const MovieFiles = ({ movie }: { movie: MovieT }) => {
    const AccordionStyle = {
        '&:before': {
            backgroundColor: 'transparent !important',
        },

    };
    return (
        <Accordion elevation={0} className="rounded-2xl mb-4 border" sx={AccordionStyle}>
            <AccordionSummary
                sx={{ border: 'none' }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"

            >
                <div className="!flex !justify-between items-center w-full">
                    <h2 className="text-xl font-bold text-black text-left">Movie file</h2>

                    <div className="border rounded-md w-10 h-10 flex items-center justify-center mr-4">
                        <BsPlus size={30} />
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>

                <Divider sx={{ borderStyle: 'dashed' }} className="mb-3" />

                <List columns={columns} data={[{
                    title: movie?.title,
                    fileSize: movie?.size || 'N/A',
                    duration: movie?.duration || 'N/A',
                }]} numbered fullSpanKey="name" />
            </AccordionDetails>
        </Accordion>
    )
}
